import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Card,
  List,
  Modal,
  Form,
  Col,
  Divider,
  Button,
  Spin,
  Select,
} from "antd";

//ANT DESIGN ICONS IMPORTS
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import TopContent from "../../../components/layouts/TopContent";
import { apiConfig, labelConfig, staticConfig } from "../../configurations/configurations.config";
import CustomButton from "../../../components/custom/CustomButton";
import dayjs from "dayjs";
import { showCheckerApprovalModal } from "../../../components/CheckerModal";

const { Text, Title } = Typography;

const NewCurrency = (props) => {
  const { userData } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const { state } = useLocation();
  const [selectedCurrencyData, setSelectedCurrencyData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [glAccountData, setGLAccountData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getGLAccountTemplate();
    getCurrencyTemplate();
  }, []);

  const getCurrencyTemplate = () => {
    let body = {
      session,
    };

    BOM.FetchReqAction(body, apiConfig.Currencies, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];
        let tempCurrrencyArray = [];

        objList?.selectedCurrencyOptions?.forEach((element) => {
          tempArray.push({
            key: element?.id,
            id: element?.id,
            currencyName: element?.name ? element?.name : "-",
            currencyCode: element?.code ? element?.code : "-",
          });
        });

        objList?.currencyOptions?.forEach((element) => {
          tempCurrrencyArray.push({
            value: element?.name,
            label: element?.name,
          });
        });

        setSelectedCurrencyData(tempArray);
        setCurrencyOptions(objList);
        setCurrencyData(tempCurrrencyArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  const getGLAccountTemplate = () => {
    const params = {
      disabled: false,
      manualEntriesAllowed: true,
      usage: 1,
    };
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, apiConfig.GLAccounts, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        const objList = res;
        let tempArray = [];

        objList?.forEach((element) => {
          tempArray.push({
            value: element?.id,
            label: element?.name ? element?.name : "-",
          });
        });

        setGLAccountData(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  function onCancel() {
    navigate("/manage-currency", { state: state });
  }

  const handleCurrencyDelete = (key) => {
    let action = "Delete  ";
    let label = key.currencyName;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + label,
      "Yes",
      "No",

      function () {
        const newData = selectedCurrencyData.filter(
          (item) => item.currencyCode !== key.currencyCode,
        );
        setSelectedCurrencyData(newData);
      },

      function () {
        // No button
      },
    );
  };

  const onSubmit = (formValues) => {
    let payloadData = [];
    selectedCurrencyData.map((element) => {
      payloadData.push({
        currency: element.currencyCode,
        glAccountId: element.glAccountId,
      });
    });
    formValues.currencies = payloadData;

    const url = `${apiConfig.Currencies}/gls`;

    const body = {
      ...formValues,
      method: "PUT",
      session,
    };

    // return
    setIsLoading(true);
    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.updateCurrency);
          navigate("/manage-currency");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/manage-currency");
          setIsLoading(false);
        },
      },
    );
  };

  return (
    <MainLayout isEnableRightSidebar={true}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.newCurrency}
        pageItems={staticConfig.newCurrencyBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={form} layout="vertical" onFinish={onSubmit}>
            <NewCurrencyModal
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              glAccountData={glAccountData}
              selectedCurrencyData={selectedCurrencyData}
              setSelectedCurrencyData={setSelectedCurrencyData}
              currencyOptions={currencyOptions}
              currencyData={currencyData}
            />

            {selectedCurrencyData?.length > 0 && (
              <List
                itemLayout="horizontal"
                dataSource={selectedCurrencyData}
                renderItem={(item, index) => (
                  <Card style={{ width: "100%", marginBottom: 20 }}>
                    <List.Item
                      actions={[
                        <Button
                          type="primary"
                          danger
                          shape="round"
                          size="small"
                          onClick={() => handleCurrencyDelete(item)}
                          icon={<DeleteOutlined />}
                          style={{
                            boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                            marginLeft: "auto",
                          }}
                        >
                          Remove
                        </Button>,
                      ]}
                    >
                      <List.Item.Meta title={item.currencyName} />
                    </List.Item>
                  </Card>
                )}
              />
            )}
            <Row>
              <Divider />
              {BOM.HasPermission("UPDATE_CURRENCY") && (
                <CustomButton
                  content="Submit"
                  style={{
                    width: "10%",
                    marginLeft: "auto",
                    boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                  }}
                  htmlType="submit"
                  backgroundColor="#92428B"
                  colorText="white"
                  hoverBackground="#AD4EA7"
                />
              )}

              <CustomButton
                content="Cancel"
                style={{
                  width: "10%",
                  marginLeft: !BOM.HasPermission("UPDATE_CURRENCY") ? "auto" : "1%",
                  boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                }}
                backgroundColor="#fff"
                colorText="black"
                hoverBackground="#F5F5F5"
                onClick={onCancel}
              />
            </Row>
          </Form>
        </Card>
      </Spin>
    </MainLayout>
  );
};

export default NewCurrency;

export const NewCurrencyModal = (props) => {
  const {
    isModalOpen,
    setIsModalOpen,
    setSelectedCurrencyData,
    selectedCurrencyData,
    glAccountData,
    currencyOptions,
    currencyData,
  } = props;

  const [useForm] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCurrencySave = (formValues) => {
    const tempCurrencyCode = currencyOptions?.currencyOptions?.find((item) =>
      item?.name?.includes(formValues.currency),
    ).code;

    const newCurrency = {
      currencyName: formValues?.currency,
      currencyCode: tempCurrencyCode,
      glAccountId: formValues?.glAccountId,
    };

    setSelectedCurrencyData([...selectedCurrencyData, newCurrency]);
    useForm.resetFields();
    handleCancel();
  };

  return (
    <Row>
      <Button
        type="primary"
        onClick={showModal}
        icon={<PlusOutlined />}
        style={{
          boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
          backgroundColor: "#92428B",
          marginBottom: 20,
        }}
      >
        Add
      </Button>

      <Modal
        title="Add New Currency"
        open={isModalOpen}
        footer={null}
        onCancel={handleCancel}
        width={1000}
      >
        <Form form={useForm} layout="vertical" onFinish={handleCurrencySave}>
          <Divider />

          <Row>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.currencyName} name="currency">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.currencyName, "select")}
                  options={currencyData}
                  showSearch
                />
              </Form.Item>
            </Col>
            <Col span={8} style={{ padding: "0px 8px" }}>
              <Form.Item label={labelConfig.glAccount} name="glAccountId">
                <Select
                  placeholder={BOM.handlePlaceholderMsg(labelConfig.glAccount, "select")}
                  options={glAccountData}
                  showSearch
                />
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Divider />
            <CustomButton
              content="Save"
              style={{
                width: "10%",
                marginLeft: "auto",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              htmlType="submit"
              backgroundColor="#92428B"
              colorText="white"
              hoverBackground="#AD4EA7"
            />

            <CustomButton
              content="Cancel"
              style={{
                width: "10%",
                marginLeft: "1%",
                boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
              }}
              backgroundColor="#fff"
              colorText="black"
              hoverBackground="#F5F5F5"
              onClick={() => setIsModalOpen(false)}
            />
          </Row>
        </Form>
      </Modal>
    </Row>
  );
};
